<template>
  <div class="home-section flex flex-center">
    <div class="home-section-inner">
      <div class="head flex flex-center flex-column flex-middle">
        <div class="head-name">友情链接</div>
        <div class="head-tips">Friendship Link</div>
      </div>
      <div class="items">
        <div
          class="item"
          v-for="(item, index) in links"
          :key="`${index}_friendshipLink`"
        >
          <el-select
            :placeholder="item.linksCategoryName"
            value-key="name"
            :value="''"
            @change="linkChange"
          >
            <el-option
              v-for="option in item.linksRespondList"
              :key="option.linksName"
              :label="option.linksName"
              :value="option"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { friendlyLink } from "@/api/home";
export default {
  name: "modular_links",
  data() {
    return {
      links: [],
      loading: false,
    };
  },
  created() {
    this.getLink();
  },
  methods: {
    async getLink() {
      const res = await this.$axios.get(friendlyLink);
      this.links = res;
    },
    linkChange(command) {
      window.open(command.linksAddress);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.items {
  display: grid;
  grid-template-columns: repeat(4, calc(25% - 15px));
  gap: 20px;
  padding: 20px;
  background: #ededed;
  &-block {
    height: 120px;
    border-radius: 12px;
    padding: 20px;
  }
  &-name {
    color: white;
    font-size: 16px;
    margin-bottom: 25px;
  }
  ::v-deep .el-select {
    width: 100%;
    .el-input__inner::placeholder {
      color: #333;
    }
  }
  ::v-deep .el-button--small {
    padding: 5px;
  }
  ::v-deep i.el-icon-arrow-down {
    font-size: 22px;
  }
}
</style>
